// Shared table renderer for the audit-log + alerts views.
// Both pages were previously hand-rolled inline; centralizing keeps the
// header style + column definitions consistent.
const TABLE = 'audit.audit_log';

function HeaderCell({ children }) {
  return (
    <th style={{ fontSize: 11, whiteSpace: 'nowrap' }}>
      <span style={{ display: 'block', fontSize: 9, fontWeight: 400, color: '#999' }}>{TABLE}</span>
      {children}
    </th>
  );
}

export function AuditTable({ rows }) {
  return (
    <table>
      <thead>
        <tr>
          <HeaderCell>Time</HeaderCell>
          <HeaderCell>Action</HeaderCell>
          <HeaderCell>Entity Type</HeaderCell>
          <HeaderCell>Entity ID</HeaderCell>
          <HeaderCell>Performed By</HeaderCell>
          <HeaderCell>Details</HeaderCell>
        </tr>
      </thead>
      <tbody>
        {rows.map((l, i) => (
          <tr key={i}>
            <td style={{ whiteSpace: 'nowrap', fontSize: 12 }}>{l.performed_at}</td>
            <td style={{ fontSize: 12 }}>
              <span
                className={`badge ${
                  l.action.includes('fail') || l.action.includes('error') ? 'failed' : 'approved'
                }`}
              >
                {l.action}
              </span>
            </td>
            <td style={{ fontSize: 12, whiteSpace: 'nowrap' }}>{l.entity_type || '-'}</td>
            <td style={{ fontSize: 12, whiteSpace: 'nowrap' }}>{l.entity_id || '-'}</td>
            <td style={{ fontSize: 12, whiteSpace: 'nowrap' }}>{l.performed_by || '-'}</td>
            <td style={{ fontSize: 12, maxWidth: 400, overflow: 'hidden', textOverflow: 'ellipsis' }}>
              {l.details}
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}

export function AlertsTable({ rows }) {
  return (
    <table>
      <thead>
        <tr>
          <HeaderCell>Time</HeaderCell>
          <HeaderCell>Type</HeaderCell>
          <HeaderCell>Details</HeaderCell>
        </tr>
      </thead>
      <tbody>
        {rows.map((a, i) => (
          <tr key={i}>
            <td style={{ whiteSpace: 'nowrap', fontSize: 12 }}>{a.performed_at}</td>
            <td style={{ fontSize: 12 }}>
              <span className="badge failed">{a.action}</span>
            </td>
            <td style={{ fontSize: 12, maxWidth: 400, overflow: 'hidden', textOverflow: 'ellipsis' }}>
              {a.details}
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}
